import React from 'react';
import {NavLink} from "react-router-dom";
import _ from "lodash";
import createLink from "../../../../libs/createLink";

import {useBreakpoint} from '../../../../libs/breakpoint';
import Dropdown from "../../Dropdown";
import Icon from "../../Icon";


const SubNavBar = ({
                       currentUserInitialized = false
                   }) => {
    //const [toggleMenu, setToggleMenu] = useState(true);
    const breakpoints = useBreakpoint();
    let isMbileSmall = !!breakpoints.xs;
    let isMobile = !!breakpoints.sm;
    let isLgDesktop = !!breakpoints.lg;
    let isTablette = !!breakpoints.md;
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";

    const linkMenu = [
        {
            to : createLink('photos'),
            label : "PHOTOS",
            icon : {
                type : "picture-c",
                className : "picto-c"
            },
            iconHover : {
                type : "picture-bw",
                className : "picto"
            },
            className : "picture-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            to : createLink('videos'),
            label : "VIDEOS",
            icon : {
                type : "film-reel",
                className : "picto-c"
            },
            iconHover : {
                type : "film-reel-bw",
                className : "picto"
            },
            className : "film-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            to : createLink('forum'),
            label : "FORUM",
            icon : {
                type : "forum-c",
                className : "picto-c"
            },
            iconHover : {
                type : "forum-bw",
                className : "picto"
            },
            className : "forum-ico",
            exact : true,
            showMini : false,
            display : true
        },
        /*{
            to : createLink('articles'),
            label : "ARTICLES",
            icon : {
                type : "article-c",
                className : "picto-c"
            },
            iconHover : {
                type : "article-bw",
                className : "picto"
            },
            className : "article-ico",
            exact : true,
            showMini : false,
            display : true
        },*/
        {
            to : `${createLink('comparatorDating')}?source=${isMobile ? "tab-mobile" : "tab-desktop"}`,
            label : "RENCONTRE",
            icon : {
                type : "meet-c",
                className : "picto-c"
            },
            iconHover : {
                type : "meet-bw",
                className : "picto"
            },
            className : `meet-ico`,
            exact : true,
            showMini : true,
            display : ["", "voissa"].includes(source)
        },
        {
            to : createLink('stories'),
            label : "HISTOIRES",
            icon : {
                type : "book-c",
                className : "picto-c"
            },
            iconHover : {
                type : "book",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : false,
            display : true
        },
        {
            to : `${createLink('webcams')}?source=${isMobile ? "tab-mobile" : "tab-desktop"}`,
            label : "WEBCAMS",
            icon : {
                type : "video-camera-c",
                className : "picto-c"
            },
            iconHover : {
                type : "video-camera",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : true,
            display : true
        },
        {
            href : "https://voissa.boutique",
            label : "BOUTIQUE",
            icon : {
                type : "shopping-cart-c",
                className : "picto-c"
            },
            iconHover : {
                type : "shopping-cart",
                className : "picto"
            },
            className : "meet-ico",
            exact : true,
            showMini : false,
            display : true
        }
    ];

    let menuShow = linkMenu.filter(item => item.display);
    let menuHide = [];
    if(isMbileSmall){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = currentUserInitialized ? 2 : 3;
        menuShow = menuSort.filter(item => item.showMini && item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(menuShow.length);
    }

    else if(isMobile){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = currentUserInitialized ? 3 : 4;
        menuShow = menuSort.filter(item => item.showMini && item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(menuShow.length);
    }
    else if(isTablette){
        let menuSort = _.orderBy(linkMenu, ['showMini'], ['desc']);
        let limit = currentUserInitialized ? 4 : 5;
        menuShow = menuSort.filter(item => item.display).slice(0,limit);
        menuHide = menuSort.filter(item => item.display).slice(limit);
    }
    else if(isLgDesktop){
        menuShow = linkMenu.filter(item => item.display);
        menuHide = []
    }


    return (
        <nav className={isTablette ? "mobile-header-menu" : ""}>
            <div className="navbar container">
                <ul className={isTablette ? "menu-row" : ""}>
                    <li className={"link-home"}><NavLink
                        className="link"
                        to="/" exact
                        activeClassName="active">
                        <div className="row picto-container home-ico">
                            <Icon type="home-c" className="picto-c"/>
                            <Icon type="home-bw" className="picto"/></div>
                        ACCUEIL
                    </NavLink>
                    </li>
                    {currentUserInitialized && (
                        <li><NavLink
                            className="link" to={createLink('actuality')} exact activeClassName="active">
                            <div className="row picto-container timeline-ico"><Icon type="timeline-c"
                                                                                    className="picto-c"/><Icon
                                type="timeline-bw" className="picto"/></div>
                            MON RÉSEAU</NavLink>
                        </li>
                    )}
                    {menuShow.map(item =>(
                        <li key={item.label} >{item.to ? <NavLink
                            className="link"
                            to={item.to}
                            //exact={item.exact}
                            activeClassName="active">
                            <div className={`row picto-container ${item.className}`}>
                                <Icon {...item.icon} />
                                <Icon {...item.iconHover}/>
                            </div>
                            {item.label}
                        </NavLink> : <a
                            href={item.href}
                            className="link"
                            rel="nofollow noopener noreferrer"
                            target={"_blank"}>
                            <div className={`row picto-container ${item.className}`}>
                                <Icon {...item.icon} />
                                <Icon {...item.iconHover}/>
                            </div>
                            {item.label}
                        </a>}
                        </li>
                    ))}
                    {menuHide.length ? (
                        <Dropdown activableComponent={(
                            <li>+</li>
                        )}>
                            <ul className="dropdown-menu">
                                {menuHide.map(item =>(
                                    <li className="menu-item" key={item.label}>
                                        {item.to ? <NavLink to={item.to} ><Icon type={item.icon.type} /> {item.label}</NavLink> : <a href={item.href} rel="nofollow noopener noreferrer" target={"_blank"}><Icon type={item.icon.type} /> {item.label}</a>}
                                    </li>
                                ))}
                            </ul>
                        </Dropdown>
                    ) : null}
                </ul>

            </div>
        </nav>
    )
}

export default SubNavBar;